import { render, staticRenderFns } from "./ExpiredLicence.vue?vue&type=template&id=1baa8ad2&scoped=true"
import script from "./ExpiredLicence.vue?vue&type=script&lang=js"
export * from "./ExpiredLicence.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLicence.vue?vue&type=style&index=0&id=1baa8ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa8ad2",
  null
  
)

export default component.exports